export default __webpack_public_path__ + "static/media/invalidDocumnetImg.a0a8ada7.svg";